// src/components/game-supergirls/GameEndedScreen.js
import React from "react";
import "./GameSupergirls.css";
import "./CheckRewardLimit.css";

import { useNavigate } from "react-router-dom";
import headerImage from "../../assets/images/game-supergirls/TamhaRak_Poster.jpg";
import biggy from "../../assets/images/game-supergirls/Sticker-Thx.png";

const GameEndedScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="quiz-container">
      <img src={headerImage} alt="header" className="quiz-header-image" />

      <h4 className="limit-title">
        กิจกรรมร่วมสนุกสิ้นสุดแล้ว <br />
        ขอบคุณทุกท่านที่ร่วมกิจกรรม
      </h4>

      <img src={biggy} alt="Thank You" className="limit-image" />

      <div className="reward-button-wrapper">
        <button className="btn-back-limit" onClick={() => navigate("/")}>
          กลับหน้าหลัก
        </button>
      </div>
    </div>
  );
};

export default GameEndedScreen;
